import { useCallback } from "react";

type StorageKey =
  | "editingProject"
  | "projectStore"
  | "templateStore"
  | "collectionStore";

export const useLocalStorage = <T extends object>() => {
  const save = useCallback((key: StorageKey, value: T) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Error saving to local storage:", error);
    }
  }, []);

  const read = useCallback((key: StorageKey): T | null => {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Error reading from local storage:", error);
      return null;
    }
  }, []);

  const remove = useCallback((key: StorageKey) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing from local storage:", error);
    }
  }, []);

  return { save, read, remove };
};
